// Querys and Mutations
import {
    ALL_ACTIVE,
    CHANGE_STATUS,
    CREATE,
    UPDATE,
    GET_WITH_PAGINATION,
    DELETE
} from '@/graphql/config/MediumHeavyGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { MediumHeavyModel, MediumHeavyForm, MediumHeavyWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class MediumHeavyService {
    /**
     * Queries
     */
    async getActivated (): Promise<MediumHeavyModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.mediumHeavyActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<MediumHeavyWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.mediumHeavyWithPagination.paginatorInfo
        const data: [MediumHeavyModel] = result.data.mediumHeavyWithPagination.data
        const response: MediumHeavyWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: MediumHeavyForm): Promise<MediumHeavyModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createMediumHeavy
    }

    async update (id: number, form: MediumHeavyForm): Promise<MediumHeavyModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateMediumHeavy
    }

    async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new MediumHeavyService()
